import ScheduleDetails from './component'

export default ScheduleDetails